import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PaywGuard } from './payw.guard';
const routes: Routes = [
  {
    path: 'home',
   // canActivate:[PaywGuard],
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  

  {
    path: 'get-started',
    loadChildren: () => import('./get-started/get-started.module').then( m => m.GetStartedPageModule)
  }
  /*,
  
  {
    path: 'board-config',
    loadChildren: () => import('./board-config/board-config.module').then( m => m.BoardConfigPageModule)
  },
  {
    path: 'board-config/:id',
    loadChildren: () => import('./board-config/board-config.module').then( m => m.BoardConfigPageModule)
  }
  ,
  */,
  {
    path: 'startup',
    loadChildren: () => import('./startup/startup.module').then( m => m.StartupPageModule)
  }
  ,
  {
    path: 'features',
    loadChildren: () => import('./features/features.module').then( m => m.FeaturesPageModule)
  },
  {
    path: 'purchase',
    loadChildren: () => import('./purchase/purchase.module').then( m => m.PurchasePageModule)
  },
  {
    path: 'purchases',
    loadChildren: () => import('./purchases/purchases.module').then( m => m.PurchasesPageModule)
  },
  {
    path: 'new-features',
    loadChildren: () => import('./new-features/new-features.module').then( m => m.NewFeaturesPageModule)
  },
  /*
  {
    path: 'bsong/:id',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
    
     },
  {
    path: 'song/:id',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
    },
 */
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
   
  },
  {
    path: 'social-media',
    loadChildren: () => import('./social-media/social-media.module').then( m => m.SocialMediaPageModule)
  },
  {
    path: 'raaga-info/:id',
    canActivate:[PaywGuard],
    loadChildren: () => import('./raaga-info/raaga-info.module').then( m => m.RaagaInfoPageModule)
  },
  {
    path: 'raaga-info',
    loadChildren: () => import('./raaga-info/raaga-info.module').then( m => m.RaagaInfoPageModule)
  }
  /*,
  {
    path: 'auth-kb',
    loadChildren: () => import('./auth-kb/auth-kb.module').then( m => m.AuthKbPageModule)
  }
    */
  ,
  {
    path: 'mp3keyboard',
    loadChildren: () => import('./mp3keyboard-page/mp3keyboard.module').then( m => m.Mp3keyboardPageModule)
  }
  ,
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then( m => m.UserPageModule)
  }
  ,
  {
    path: 'sound-tester',
    loadChildren: () => import('./sound-tester/sound-tester.module').then( m => m.SoundTesterPageModule)
  }
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
